"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_SUPPORT_EMAIL = void 0;
exports.DEFAULT_SUPPORT_EMAIL = "lingoshade@lsnlab.com";
//# sourceMappingURL=contactSettings.js.map